import { IDs } from '../../../../helpers/IDs';



export function processKennzahlen(data: any, aufnahmeData: any, gewerk: number, betriebliche_situation: string) {
    const list = [];
    const arr_def = data[IDs.ENT_KENNZAHLEN_DEFINTION];    // Zuerst die Kennzahlen selbst
    const branchen_gewerke_tid = gewerk;
    console.log('Arr def', arr_def);
    const keys = aufnahmeData.keys;
    const kennziffern = aufnahmeData.kennziffern;
    const groups = aufnahmeData.groups;
    const gewerk_flags = aufnahmeData.gewerk_flag;
    const berechnet_flags =  aufnahmeData.berechnet_flag;
    for (let i = 0; i < keys.length; i++) {
        const kuerzel = keys[i];
        if (kuerzel &&  kennziffern[kuerzel]) {
            // Gruppe finden
            let group = '';
            for (let j = i; j > 0 ; j--) {
                if (groups[j]) {
                    group = groups[j];
                    break;
                }
            }
            const name_raw = kennziffern[kuerzel].replace('\r', '').replace('\n', ' ').replace('CO2', 'CO₂');
            const name_split = name_raw.split('[');
            let name = name_split.length > 1 ? name_split[0].trim() : name_raw.trim();
            /*if (group && group !== '') {
                name = group + ' - ' + name;
            }*/
            const einheit = name_split.length > 1 ? name_split[1].replace(']', '').trim() : '';
            const is_gewerk = gewerk_flags[i];
            const is_berechnet = berechnet_flags[i];
            const beschreibung = name;
            // Fürs Gewerk
            const foundOld = arr_def.find((ad: any) => ad.kuerzel === kuerzel && ad.branchen_gewerke_tid_orig === branchen_gewerke_tid);
            const tid =  foundOld ? foundOld.tid : 0;
            const kz = {tid, branchen_gewerke_tid, name, kuerzel, beschreibung, einheit, is_gewerk, is_berechnet};
            // Für die Betriebliche Situation
            const foundOld2 = arr_def.find((ad: any) => ad.kuerzel === kuerzel && ad.betriebliche_situation === betriebliche_situation);
            const tid2 =  foundOld2 ? foundOld2.tid : 0;
            const kz2 = {tid: tid2, branchen_gewerke_tid: -1, betriebliche_situation, name, kuerzel, beschreibung, einheit,
                            is_gewerk, is_berechnet};
            // console.log('KZ', kz);
            list.push(kz);
            list.push(kz2);

        }
    }
    return list;

}


export function processKennzahlenWerte(data: any, aufnahmeData: any, gewerk: number, betriebliche_situation: string) {
    console.log(aufnahmeData);
    const arr_def = data[IDs.ENT_KENNZAHLEN_WERTE_ZENTRAL];    // Zuerst die Kennzahlen selbst

    const list: Array<any> = [];
    const daten = aufnahmeData.daten;
    const branchen_gewerke_tid = gewerk;
    const berechnet_flags =  aufnahmeData.berechnet_flag;
    for (let i = 0; i < daten.length; i++) {
        const row = daten[i];
        const jahr = row.jahr;
        const betrieb = row.betrieb;
        const keys = aufnahmeData.keys;
        for (let j = 0; j < keys.length; j++) {
            const kuerzel = keys[j];
            if (!kuerzel || berechnet_flags[j]) {
                // Keine berechneten Werte speichern
                // console.log('Not importing: ', kuerzel);
                continue;
            }
            const value = +row[kuerzel];
            if (value && !isNaN(value)) {
                const wert = value;
                const foundOld = arr_def.find((ad: any) => ad.kuerzel === kuerzel &&
                                                           ad.branchen_gewerke_tid_orig === branchen_gewerke_tid &&
                                                           ad.betriebliche_situation === betriebliche_situation &&
                                                           ad.betrieb === betrieb &&
                                                           ad.jahr === jahr);
                const tid = foundOld ? foundOld.tid : 0;
                const item = {tid, branchen_gewerke_tid, kuerzel, jahr, betrieb, wert, betriebliche_situation};
                list.push(item);
            }
        }


    }
    return list;
}

